import { createContext } from "react";

export interface INotificationsContext {
  isOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
}

export const NotificationsContext = createContext<INotificationsContext | null>(
  null,
);
